export default "__VITE_ASSET__6zlL9BMH__"